yourStaffProgres.vue
<template>
    <div class="container-fluid position-relative bg-BAT">

        <div v-if="activities === null">
            <loading></loading>
        </div>
        <div v-else>
            <div class="container watch-container py-4">
                <div>
                    <div class="breadcrumbs-retos d-flex flex-column pb-2">
                        <div>
                            <a href="/home-bat">
                                <img src="/img/icons/homeBread.svg" alt=""/>
                                Home
                            </a>
                            <a id="practica" class="link cursor-pointer link-active-bread"
                               href="/home-bat">Gestión del equipo</a>
                            <span id="optionP" class="d-none color-active-miga"></span>
                        </div>
                    </div>
                    <a class="pb-2 pt-2" href="/home-bat"><img src="/img/icons/regresar.svg" alt="icon"></a>
                </div>
            </div>

            <div class="container mt-3">
                <div>
                    <div class="row mb-4">
                        <div class="col-12 col-md-12 col-lg-4 order-1 order-md-1">
                            <div class="header-portfolio d-flex flex-column">
                                <h5 class="text-title-bat mb-2">Gestión del equipo</h5>
                                <el-alert v-if="showAlert" class="custom-alert" type="warning" show-icon style="position: fixed; top: 107px; right: 8%; z-index: 2000; border: 1px solid #FFBA01; background-color: #FEFFE3; border-radius: 8px;">
                                    <div class="text-black">
                                        <strong>Impulsa a tu equipo : </strong> si ellos pierden puntos, tú también dejas de ganar.
                                    </div>
                                </el-alert>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-lg-4 order-3 order-md-3">
                            <a :href="`/get-pdv-details/${selectedPdv}`" class="text-decoration-none">
                                <button
                                    class="rounded-3 bg-transparent p-2 px-3 my-1 text-bat align-items-center border border-gray text-decoration-none text-secondary text-bat text-center aling-items-center border border-secondary rounded-4 justify-content-center py-2 px-2">
                                    <img class="me-2" src="/img-version2/icons/staff/staff-progress.svg" alt="Progreso">
                                    <span class="text-title-bat">Estado actual de cada usuario</span>
                                    <span> ></span>
                                </button>
                            </a>
                        </div>
                        <div class="col-12 col-md-6 col-lg-4 order-2 order-md-2" v-if="admin_staff_segments.includes(client_segment)">
                            <div class="filter-month-staff">
                                <div class="custom-select" ref="customSelect" @click="toggleDropdown" :class="{ open: isOpen }">
                                    <div v-if="!isOpen" class="selected-option" @click="toggleDropdown">
                                        <div class="pdv-name" @click="toggleDropdown">
                                            {{ selectedPdvObj ? truncateText(selectedPdvObj.name_pdv, 35) : 'Selecciona un PDV' }}
                                        </div>
                                        <div class="pdv-address" v-if="selectedPdvObj" @click="toggleDropdown">
                                            <img src="/img-version2/icons/staff/location.svg" alt="location">
                                            {{ truncateText(selectedPdvObj.address_pdv, 35) }}
                                        </div>
                                    </div>
                                    <div v-else class="search-box" @click.stop>
                                        <input
                                            type="text"
                                            v-model="searchQuery"
                                            placeholder=""
                                            ref="searchInput"
                                        />
                                    </div>
                                    <i class="arrow" :class="{ open: isOpen }"></i>
                                </div>

                                <div v-if="isOpen" class="options-list" ref="optionsList">
                                    <div
                                        v-for="pdv in filteredPdvs"
                                        :key="pdv.id"
                                        class="option-item"
                                        @click.stop="selectPdv(pdv)"
                                    >
                                        <div class="pdv-name">
                                            {{ truncateText(pdv.name_pdv, 35) }}
                                        </div>
                                        <div class="pdv-address">
                                            <img src="/img-version2/icons/staff/location.svg" alt="location">
                                            {{ truncateText(pdv.address_pdv, 35) }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="activities?.length !== 0" class="row d-flex justify-content-center">
                        <div v-for="(activity, index) in activities" :key="index" class="text-bat col-12 col-md-6 col-lg-4 mb-3">
                            <div class="bg-white shadow-sm rounded-4 px-0">
                                <div class="position-relative" style="height: 30px;">
                                    <div class="position-absolute top-0 start-0 d-flex align-items-center">
                                        <div class="d-flex align-items-center">
                                            <div class="category p-1 px-2 object-fit-contain rounded-2 text-bat">
                                                <p class="mb-0 text-indigo-darkness fw-bold">
                                                    <small v-if="activity.type  === 'survey'">Encuestas</small>
                                                    <small v-if="activity.type  === 'challenge'">Retos</small>
                                                    <small v-if="activity.type  === 'learning'">Aprendizaje</small>
                                                    <small v-if="activity.type  === 'entertainment'">Entretenimiento</small>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="activity.season" class="position-absolute top-0 end-0 d-flex align-items-center">
                                        <div class="ticket_season_staff p-1 px-2 object-fit-contain rounded-1">
                                            <p class="mb-0 text-black">
                                                <img src="/img-version2/icons/staff/Llamas%2024x24.svg" alt=""><b><small><strong>En Racha</strong></small></b></p>
                                        </div>
                                    </div>
                                </div>
                                <div class="px-3 pb-4">
                                    <div>
                                        <h5 class="text-title-bat">
                                            {{ activity.title }}
                                        </h5>
                                    </div>
                                    <div>
                                        <p class="mb-1">Usuarios asignados : {{ activity.total_staff }}</p>
                                    </div>
                                    <div class="mt-2">
                                        <el-collapse v-model="collapseStates[index]" accordion>
                                            <el-collapse-item :title="`Pendientes por completar ${activity.missing}`" name="1">
                                                <div>
                                                    {{ activity.names }}
                                                </div>
                                            </el-collapse-item>
                                        </el-collapse>
                                    </div>
                                    <div class=" mt-2">
                                        <p class="mb-3">Puntos a perder : {{ activity.points_missing }}</p>
                                    </div>
                                    <div>
                         <span
                             class="my-2 rounded-5 border border-info text-info px-2 py-1 fw-bold text-btn-outstanding">
                              <img class="mx-1" src="/img/icons/clock_win_points.svg" alt="vencimiento">
                              Queda {{ calculateTime(activity.expiration_date_end) }}
                            </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-else class="row">
                        <no-data-staff
                            :title="'¡Todo al día!'"
                            :description="'Tu Staff no tiene actividades pendientes por ahora.'"
                        ></no-data-staff>
                    </div>

                </div>


            </div>
        </div>

    </div>
</template>

<script>

import {EventBus} from "../../app";

export default {
    props: {
        client_id: {
            default: null
        },
        pdv: {
            default: null
        },
        client_segment: {
            default: null,
        },
        admin_staff_segments: {
            default: [],
        },
    },
    data() {
        return {
            loading: 1,
            pdvs: [],
            selectedPdv: null,
            activities: null,
            getWidth() {
                if (this.$mq === 'sm') {
                    return '95%';
                } else if (this.$mq === 'md') {
                    return '35%';
                } else if (this.$mq === 'lg') {
                    return '30%';
                } else {
                    return '20%';
                }
            },
            collapseStates: {},
            showAlert: false,
            isOpen:false,
            searchQuery: "",
        };
    },

    mounted() {
        this.selectedPdv = this.pdv.id;
        this.getActivePdvs();
        document.addEventListener('click', this.handleClickOutside);
    },
    beforeUnmount() {
        document.removeEventListener('click', this.handleClickOutside);
    },
    computed: {
        isButtonDisabled() {
            const selectedPdvData = this.pdvs.find(pdv => pdv.id === this.selectedPdv);
            return selectedPdvData && selectedPdvData.places <= (this.requests.length + this.client.length);
        },
        selectedPdvObj() {
            return this.pdvs.find(p => p.id === this.selectedPdv) || null
        },
        filteredPdvs() {
            if (!this.searchQuery) return this.pdvs;
            return this.pdvs.filter(pdv =>
                pdv.name_pdv.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
                pdv.address_pdv.toLowerCase().includes(this.searchQuery.toLowerCase())
            );
        },
    },
    methods: {
        getPdvProgress(pdv_id) {
            this.activities = null;
            axios.get(`/get-pdv-progress/${pdv_id}`)
                 .then(({data}) => {
                     this.activities = data.activities;
                     this.activities.forEach((_, index) => {
                         this.$set(this.collapseStates, index, index === 0 ? null : null);
                     });
                 })
                 .catch(error => {
                     console.error("Error no se pudo obtener datos");
                     this.activities = [];
                 })
        },
        getActivePdvs() {
            axios.get('/get-active-pdvs')
                 .then(({data}) => {
                     this.pdvs = data.pdvs;
                     if (this.pdvs.length > 0) {
                         this.getPdvProgress(this.selectedPdv);
                         this.showAlertWarning();
                     }
                 })
                 .catch(error => {
                     console.error("Error al obtener los PDVs activos", error);
                 });
        },
        calculateTime(date) {
            const now = new Date();
            const diferenciaEnMilisegundosWin = new Date(date) - now;
            let minutosTranscurridosWin = Math.floor(diferenciaEnMilisegundosWin / (1000 * 60));
            let mensajeTiempoWin = '';
            if (minutosTranscurridosWin >= 43200) {
                var mes = Math.floor(diferenciaEnMilisegundosWin / (1000 * 60 * 60 * 24 * 30));
                if (mes == 1) {
                    mensajeTiempoWin = mes + " mes";
                } else {
                    mensajeTiempoWin = mes + " meses";
                }
            } else if (minutosTranscurridosWin >= 1440) {
                var dia = Math.floor(diferenciaEnMilisegundosWin / (1000 * 60 * 60 * 24));
                if (dia == 1) {
                    mensajeTiempoWin = dia + " día";
                } else {
                    mensajeTiempoWin = dia + " días";
                }
            } else if (minutosTranscurridosWin >= 60) {
                var hora = Math.floor(diferenciaEnMilisegundosWin / (1000 * 60 * 60));
                if (hora == 1) {
                    mensajeTiempoWin = hora + " hora";
                } else {
                    mensajeTiempoWin = hora + " horas";
                }
            } else if (minutosTranscurridosWin <= 60) {
                var minuto = Math.floor(diferenciaEnMilisegundosWin / (1000 * 60));
                if (minuto == 1) {
                    mensajeTiempoWin = minuto + " minuto";
                } else {
                    mensajeTiempoWin = minuto + " minutos";
                }
            }
            return mensajeTiempoWin;
        },
        showAlertWarning() {
            this.showAlert = true;

            setTimeout(() => {
                this.showAlert = false;
            }, 10000);

        },
        changeSelectedPDV(pdvId) {
            this.loading++;
            axios.post('/change-selected-pdv', { pdv_id: pdvId })
                 .then(response => {
                     history.replaceState({}, null, `/pdv-progress/${pdvId}`);
                     EventBus.$emit('change-select-pdv', { select_pdv: pdvId });
                     this.getPdvProgress(pdvId);
                 })
                 .catch(error => {
                     console.error('Error al cambiar el PDV seleccionado:', error);
                     this.loading--;
                 });
        },
        toggleDropdown() {
            this.isOpen = !this.isOpen
            if (this.isOpen) {
                this.$nextTick(() => {
                    this.$refs.searchInput.focus();
                });
            } else {
                this.searchQuery = "";
            }
        },
        selectPdv(pdv) {
            this.selectedPdv = pdv.id;
            this.isOpen = false;
            this.searchQuery = "";
            this.changeSelectedPDV(pdv.id);
        },
        truncateText(text, maxLength) {
            if (!text) return 'Sin Dirección'
            return text.length > maxLength ? text.substring(0, maxLength) + '...' : text
        },
        handleClickOutside(event) {
            const clickInside = this.$refs.customSelect.contains(event.target) ||
                (this.$refs.optionsList && this.$refs.optionsList.contains(event.target));
            if (!clickInside) {
                this.isOpen = false;
                this.searchQuery = "";
            }
        }
    }
};
</script>
